// **  Initial State
const initialState = {
  data: [],
  start: 0,
  end: 0,
  totalRecords: 0,
  totalPages: 0,
  percentage: 0,
  params: {},
  all: [],
  loading: true,
}

const brand = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_BRANDS':
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
        loading: false,
      }

    case 'BRANDS_LOADING':
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default brand
